import BaseListModel from './BaseListModel'

import { instanceStore } from './InstanceModel'
import { machineStore } from './MachineModel'
import { shelfStore } from './ShelfModel'
import { userCertStore } from './UserCertModel'
import { userStore } from './UserModel'

export const LIST_MODEL_KEYS = {
  INSTANCE: 'instance',
  MACHINE: 'machine',
  USER_CERT: 'user_cert',
  USER: 'user',
  SHELF: 'shelf',
}

const storeMap = new Map<string, BaseListModel>([
  [LIST_MODEL_KEYS.INSTANCE, instanceStore],
  [LIST_MODEL_KEYS.MACHINE, machineStore],
  [LIST_MODEL_KEYS.SHELF, shelfStore],
  [LIST_MODEL_KEYS.USER_CERT, userCertStore],
  [LIST_MODEL_KEYS.USER, userStore],
])

export default class ListLoader {
  models = new Set<string>()

  reloadListPage() {
    this.models.forEach((type) => {
      if (!storeMap.has(type)) {
        return
      }
      storeMap.get(type).reloadCurrentPage()
    })
  }

  registerModel(type: string) {
    this.models.add(type)
  }

  removeModel(type: string) {
    this.models.delete(type)
  }
}

export const listLoader = new ListLoader()
